import React, { useState } from "react";

export default ({ children, content, width, left }) => {
  return (
    <abbr title={content} style={{ border: "none", textDecoration: "none" }}>
      {children}
    </abbr>
  );
};
